import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { phase10Api } from '../api/phase10Client';

export function MacroOutcomesPage() {
  const [dashboard, setDashboard] = useState<any>(null);
  const [eq, setEq] = useState<any>(null);

  useEffect(() => {
    Promise.all([api.dashboard(), phase10Api.equilibrium()])
      .then(([d, e]) => { setDashboard(d); setEq(e); })
      .catch(() => {});
  }, []);

  const sr = dashboard?.scenario_result;
  const outcomes = [
    { name: 'Real GDP growth', value: sr?.simulated_gdp_growth, status: 'Active — equilibrium-adjusted' },
    { name: 'Unconstrained GDP', value: sr?.unconstrained_gdp_growth ?? sr?.simulated_gdp_growth, status: 'Linkage sum before constraints' },
    { name: 'Exports growth', value: eq?.blocks?.find((b: any) => b.output_variable_id === 'CORE_EXPORT_GROWTH')?.value, status: 'Export sub-model output' },
    { name: 'LSM growth', value: eq?.blocks?.find((b: any) => b.output_variable_id === 'PM_044')?.value, status: 'Industry sub-model output' },
    { name: 'Energy cost index', value: eq?.blocks?.find((b: any) => b.output_variable_id === 'IND_ENERGY_COST_INDEX')?.value, status: 'Energy sub-model output' },
    { name: 'Fiscal impulse', value: eq?.blocks?.find((b: any) => b.output_variable_id === 'IND_FISCAL_IMPULSE')?.value, status: 'Macro sub-model output' },
    { name: 'Inflation', value: null, status: 'Constraint — penalty if above threshold' },
    { name: 'Current account / BOP', value: eq?.binding_constraints?.length ? eq.binding_constraints.join('; ') : 'Not binding', status: 'BOP ceiling when simulated GDP exceeds sustainable rate' },
  ];

  return (
    <div>
      <h1 className="page-title">Macro Outcomes</h1>
      <p className="page-subtitle">
        Endogenous outcomes from the Energy → Industry → Export → Macro equilibrium chain, with binding constraint flags.
      </p>
      <div className="card">
        <table className="data-table">
          <thead>
            <tr><th>Outcome</th><th>Value</th><th>Status</th></tr>
          </thead>
          <tbody>
            {outcomes.map((o) => (
              <tr key={o.name}>
                <td>{o.name}</td>
                <td>{typeof o.value === 'number' ? `${o.value.toFixed(2)}${o.name.includes('index') || o.name.includes('impulse') ? '' : '%'}` : o.value ?? '—'}</td>
                <td style={{ fontSize: '0.85rem' }}>{o.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
